import clevertap from 'clevertap-web-sdk'

export const CLEVERTAP_LOG_MODE_DISABLED = 0
export const CLEVERTAP_LOG_MODE_ERRORS_ONLY = 1
export const CLEVERTAP_LOG_MODE_ERRORS_AND_INFO = 2
export const CLEVERTAP_LOG_MODE_ALL = 3

const CLEVERTAP_EVENT_PAGEVIEW = "website_page_view"

export function init(accountId, logMode) {
	clevertap.privacy.push({optOut: false})
	clevertap.privacy.push({useIP: false})

	clevertap.init(accountId)

	clevertap.setLogLevel(logMode)

	clevertap.notifications.push({
		"titleText":'Would you like to receive Push Notifications?',
		"bodyText":'We promise to only send you relevant content and give you updates on your transactions',
		"okButtonText":'Sign me up!',
		"rejectButtonText":'No thanks',
		"okButtonColor":'#f28046',
	});
}

export function trackPageView(pageCode, params) {
	clevertap.event.push(CLEVERTAP_EVENT_PAGEVIEW, {
		"page_code": pageCode,
		...params,
	});
}

export function trackEvent(eventName, params) {
	clevertap.event.push(eventName, params);
}
